import { createApi } from '@reduxjs/toolkit/query/react'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const devicesApi = createApi({
  reducerPath: 'devicesApi',
  refetchOnFocus: false,
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    getPhoneNumberValidationCode: builder.query({
      query: (requestParams: GetPhoneNumberValidationCodeParams) =>
        generateRPCQuery(
          apiConstants.DEVICES_RPC_PATH,
          'getPhoneNumberValidationCode',
          requestParams
        )
    }),
    migratePhoneVerification: builder.mutation({
      query: (requestParams: migratePhoneVerificationParams) =>
        generateRPCQuery(
          apiConstants.DEVICES_RPC_PATH,
          'migratePhoneVerification',
          requestParams
        )
    }),
    verifyAccount: builder.mutation({
      query: (requestParams: verifyAccountParams) =>
        generateRPCQuery(
          apiConstants.DEVICES_RPC_PATH,
          'verifyAccount',
          requestParams
        )
    })
  })
})

export const {
  useMigratePhoneVerificationMutation,
  useLazyGetPhoneNumberValidationCodeQuery,
  useVerifyAccountMutation
} = devicesApi
